/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Change, ChangeOptions, ObservableModel } from '@typescript-kit/core';

export interface LetterHeaderData {
  sender?: string;
  recipient?: string;
  editor?: string;
  subject?: string;
  salutation?: string;
}

export class LetterHeaderKey {
  static readonly SENDER = 'sender';
  static readonly RECIPIENT = 'recipient';
  static readonly EDITOR = 'editor';
  static readonly SUBJECT = 'subject';
  static readonly SALUTATION = 'salutation';
}

export class LetterHeader implements LetterHeaderData {
  readonly sender: string;
  readonly recipient: string;
  readonly editor: string;
  readonly subject: string;
  readonly salutation: string;

  constructor(data: LetterHeaderData) {
    this.sender = data.sender;
    this.recipient = data.recipient;
    this.editor = data.editor;
    this.subject = data.subject;
    this.salutation = data.salutation;
  }
}

export class LetterHeaderModel extends ObservableModel implements LetterHeaderData {
  static readonly KEYS = Object.keys(LetterHeaderKey).map((key) => LetterHeaderKey[key]);

  constructor(values: LetterHeaderData) {
    super(values, LetterHeaderModel.KEYS);
  }

  get sender(): string {
    return this.get(LetterHeaderKey.SENDER);
  }

  set sender(value: string) {
    this.set(LetterHeaderKey.SENDER, value);
  }

  get recipient(): string {
    return this.get(LetterHeaderKey.RECIPIENT);
  }

  set recipient(value: string) {
    this.set(LetterHeaderKey.RECIPIENT, value);
  }

  get editor(): string {
    return this.get(LetterHeaderKey.EDITOR);
  }

  set editor(value: string) {
    this.set(LetterHeaderKey.EDITOR, value);
  }

  get subject(): string {
    return this.get(LetterHeaderKey.SUBJECT);
  }

  set subject(value: string) {
    this.set(LetterHeaderKey.SUBJECT, value);
  }

  get salutation(): string {
    return this.get(LetterHeaderKey.SALUTATION);
  }

  set salutation(value: string) {
    this.set(LetterHeaderKey.SALUTATION, value);
  }

  setValues(values: LetterHeaderData, options?: ChangeOptions): { [p: string]: Change<any> } {
    return super.setValues(values, options);
  }
}

